import AuthService from '@/services/AuthServices';

const storeUser  = localStorage.getItem('user')
const user= JSON.parse(JSON.stringify(storeUser));

const initialState = user
  ? { status: { loggedIn: true }, user }
  : { status: { loggedIn: false }, user: null };

export const auth = {
  namespaced: true,
  state: initialState,
  actions: {
        async login({ commit }, user){
            console.log("Modulo de Inicio")
            return AuthService.login(user).then(
              user => {
                commit('loginSuccess', user);
                return Promise.resolve(user);
              },
              error => {
                commit('loginFailure');
                return Promise.reject(error);
              }
            );
        },
      async logout({ commit }) {
        AuthService.logout();
        commit('logout');
      },
      async register({ commit }, user) {
        return AuthService.register(user).then(
          response => {
            commit('registerSuccess');
            return Promise.resolve(response.data);
          },
          error => {
            commit('registerFailure');
            return Promise.reject(error);
          }
        );
      }
  },
  mutations: {
    loginSuccess(state, user) {
      state.status.loggedIn = true;
      state.user = user;
    },
    loginFailure(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    logout(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    registerSuccess(state) {
      state.status.loggedIn = false;
    },
    registerFailure(state) {
      state.status.loggedIn = false;
    }
  }
};